import React from 'react'
import {Icon} from '@chakra-ui/react'

const CheckIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="transparent" data-testid="check-icon" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.0325 14.0878L16.255 29.0685L8.9668 22.1484L11.0325 19.9728L16.255 24.9316L29.9668 11.9122L32.0325 14.0878Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CheckIcon
